export const noteCreationPayload = (data) => {
  let objectTemp = {
    content: data.content,
    files: data.files,
    links: data?.links,
    model_type: "contact",
    model_id: data.contact_id,
    users: data.users,
    contacts: data.contacts,
  };

  return objectTemp;
};

export const noteUpdatePayload = (data) => {
  let objectTemp = {
    content: data.content,
    files: data.files,
    links: data?.links,
    users: data.users,
    contacts: data.contacts,
  };

  return objectTemp;
};
